export const INTERVAL_TIMES = {
  FIVE_MINUTES: 1000 * 60 * 5,
  FIVE_SECONDS: 1000 * 5,
  ONE_MINUTE: 1000 * 60,
  ONE_SECOND: 1000,
  TEN_MINUTES: 1000 * 60 * 10,
  TEN_SECONDS: 1000 * 10,
  TIME_CAN_JOIN_MEETING_IN_MINUTES: 1.25 * 60,
  HOURS: {
    TWO: 1000 * 60 * 60 * 2,
  },
  MINUTES: {
    ONE: 1000 * 60,
  },
  SECONDS: {
    ONE: 1000,
  },
};
